var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';
import { Inset } from './inset';
import { Pane } from './pane';
import { Text } from './text';
export function ErrorPane(_a) {
    var { error, background } = _a, props = __rest(_a, ["error", "background"]);
    return (_jsx(Pane, Object.assign({}, props, { background: background !== null && background !== void 0 ? background : 'secondary', children: _jsxs(Inset, { className: "flex flex-col items-center justify-center gap-2", children: [_jsx(ExclamationTriangleIcon, { className: "size-6 sm:size-5 text-zinc-500 dark:text-zinc-400" }), _jsx(Text, { children: error.message })] }) })));
}
